import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import { observer, inject } from "mobx-react";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import TrailersGridFilter from "./TrailersGridFilter";
const styles = (theme) => ({
  container: {
    height: "100%",
  },
});
@inject("DispatchStore")
@observer
class QuickFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quickFilterIsVisible: true,
      isLoading: false,
    };
    this.initialWidth = this.props.glContainer.width;
  }
  // Toggles the visibility of quick filter panel
  toggleQuickFilterVisibility = (visible = null) => {
    const visibility = [true, false].includes(visible)
      ? visible
      : !this.state.quickFilterIsVisible;
    const width = visibility ? this.initialWidth : 40;
    this.props.glContainer.parent.container.setSize(width);

    this.setState({
      quickFilterIsVisible: visibility,
    });
  };

  getFilterProps = () => {
    return {
      initialWidth: this.initialWidth,
      glContainer: this.props.glContainer,
      glEventHub: this.props.glEventHub,
      quickFilterIsVisible: this.state.quickFilterIsVisible,
      toggleQuickFilterVisibility: this.toggleQuickFilterVisibility,
    };
  };
  render() {
    const { classes } = this.props;

    const gridname = this.props.DispatchStore.currentGridName;
    return (
      <div className={classes.container}>
        {gridname === "TrailersGrid" || gridname === "DispatchKPI" ? (
          <TrailersGridFilter {...this.getFilterProps()} />
        ) : null}
      </div>
    );
  }
}

export default compose(withStyles(styles), withUserProfile)(QuickFilter);
